import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationResult, useQueryClient } from 'react-query';
import { ErrorMessage } from 'types';
import { client } from 'utils/api-client';

export default function useDeleteNote(): UseMutationResult<
  AxiosResponse<null>,
  AxiosError<ErrorMessage>,
  string
> {
  const queryClient = useQueryClient();

  const deleteNote = (noteId: string): Promise<AxiosResponse<null>> => {
    return client.delete(`notes/${noteId}/`);
  };

  return useMutation(deleteNote, {
    onSuccess: () => {
      queryClient.invalidateQueries('notes');
    },
  });
}
